import React from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-119">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-120" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-121" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-6 pb-10 text-center" data-id="element-122">
        <p className="text-familia-gold font-semibold text-[10px] sm:text-xs uppercase tracking-[0.25em] mb-2" data-id="element-123">
          Vitalidad 360 · Master Kit Adultos Mayores
        </p>

        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-4 text-[24px]" data-id="element-124">
          El Sistema Completo para el Cuidado del Adulto Mayor —{' '}
          <br className="hidden md:block" data-id="element-125" />
          <span className="text-familia-cyan" data-id="element-126">
            Sin Agotarte, Sin Miedo y Sin Improvisar
          </span>
        </h1>

        {/* Mockup directly below the title */}
        <div className="relative max-w-[320px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-5" style={{
        aspectRatio: '3 / 2'
      }} data-id="element-127">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-cyan/20 rounded-full hidden md:block" style={{
          filter: 'blur(70px)'
        }} data-id="element-128" />
          <img src="https://cdn.magicpatterns.com/uploads/nQuCFAXjN5rWqH1CYg6bzM/ChatGPT_Image_28_may_2026__09_10_42_p.m.-removebg-preview.png" alt="Vitalidad 360 Master Kit — Kinesiólogo presentando el sistema" width="560" height="373" loading="eager" className="relative z-10 w-full h-full object-contain" style={{
          filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.45))'
        }} data-id="element-129" />
        </div>

        <p className="text-familia-gray sm:text-sm max-w-xl mx-auto mb-4 text-[11px] leading-relaxed" data-id="element-130">
          5 Módulos + Módulo VIP EJERCICIOS + 3 Bonos: Todo explicado. En letra
          grande. Sin improvisar. Sin adivinar.
        </p>

        <div className="flex flex-wrap gap-1.5 mb-4 items-start justify-center" data-id="element-131">
          {['📄 PDF Digital', '⚡ Acceso Inmediato', '👴 Adultos Mayores y Cuidadores', '💥 Sistema Completo 2026'].map((badge, i) => <span key={i} className="bg-familia-card border border-familia-cyan/25 px-2.5 py-1 rounded-full text-[9px] sm:text-[11px] font-bold flex items-center gap-1.5" data-id="element-132">
              {badge}
            </span>)}
        </div>

        <CTAButton href="#precio-lanzamiento" className="w-full sm:w-auto text-base px-10 py-3.5 mb-3" data-id="element-133">
          → LO QUIERO AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[9px] sm:text-[11px] text-familia-gray" data-id="element-134">
          <span className="flex items-center gap-1.5" data-id="element-135">
            🛡️ Garantía de satisfacción de 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-136">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-137">
            💳 Tarjetas de Crédito/Débito
          </span>
        </div>
      </div>
    </header>;
};